/**
 * Filter incoming rows to only those not already present in existing records.
 *
 * @param existingKeys - Array of string keys already present (e.g. from existing store records)
 * @param incoming     - Array of incoming rows to filter
 * @param rowKeyFn     - Function that returns a comparable string key for an incoming row
 * @returns            - Subset of `incoming` whose key is not in `existingKeys`
 */
export function filterNewRows<U>(
  existingKeys: string[],
  incoming: U[],
  rowKeyFn: (row: U) => string,
): U[] {
  const seen = new Set(existingKeys);
  return incoming.filter(row => !seen.has(rowKeyFn(row)));
}
